<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.country.id"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@change:value="getCities"
						@update:value="setCity"
						:options="multiSelectState.citiesSelect"
						rules="required"
						name="City"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.city.id"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setStarRating"
						:options="multiSelectState.starRating"
						rules="required"
						name="Star Rating"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.starRating"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setRoomType"
						:options="multiSelectState.roomType"
						rules="required"
						name="Room Type"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.roomType"
					/>
				</div>

				<div class="from-group col-sm-3">
					<BaseInput
						name="Date"
						label="CheckIn Date"
						type="date"
						v-model="data.checkIn"
						:min="`${new Date().getFullYear()}-${
							new Date().getMonth() + 1 < 10
								? '0' + (new Date().getMonth() + 1)
								: new Date().getMonth() + 1
						}-${new Date().getDate() + 1}`"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-3">
					<BaseInput
						name="Date"
						label="CheckOut Date"
						type="date"
						:min="
							data.checkIn ||
							`${new Date().getFullYear()}-${
								new Date().getMonth() + 1 < 10
									? '0' + (new Date().getMonth() + 1)
									: new Date().getMonth() + 1
							}-${new Date().getDate() + 1}`
						"
						v-model="data.checkOut"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-3">
					<BaseInput
						name="Number of Nights"
						label="Number of nights"
						type="number"
						:min="1"
						:max="10"
						v-model="data.numberOfNights"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-3">
					<BaseInput
						name="Budget"
						label="Budget"
						type="number"
						:min="2000"
						v-model="data.budget"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setHotel"
						:options="multiSelectState.hotels"
						rules="required"
						name="Hotel"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.hotel"
					/>
				</div>
				<div class="from-group col-sm-3">
					<BaseInput
						name="Number of Rooms"
						label="Number of rooms"
						type="number"
						:min="1"
						:max="10"
						v-model="data.numberOfRooms"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";
	import API from "@/config/api";
	import Data from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "LeadHotelBooking",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Array, Object, String], default: "" },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				country: {
					id: 0,
					name: null,
				},
				city: {
					id: 0,
					name: null,
				},
				roomType: null,
				starRating: 0,
				checkIn: null,
				checkOut: null,
				numberOfNights: 0,
				budget: null,
				hotel: null,
				numberOfRooms: 0,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.country.name &&
						data.city.name &&
						data.checkIn &&
						data.checkOut
					) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const formState = reactive({
				isLoading: false,
				disabled: true,
			});

			const multiSelectState = reactive({
				cities: [],
				citiesSelect: [],
				countries: [],
				countriesSelect: [],
				starRating: Data.rating,
				roomType: Data.roomTypes,
				hotels: [],
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const getHotels = async (data) => {
				try {
					const response = await API.privateRequest.get(
						`Hotels?city=${data.city || ""}`,
					);
					const hotels = response.data.data.map((hotel) => ({
						value: hotel._id,
						label: hotel.name,
					}));
					multiSelectState.hotels = response.data.data;
					multiSelectState.hotels = hotels;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;

				getCities({ country: data.country.name });
			};

			const getCities = async (cityObj) => {
				let queryData = {};
				if (cityObj?.country) {
					queryData.countryName = cityObj?.country;
				} else if (cityObj.name.length < 3) return;
				else queryData.name = cityObj.name;

				try {
					const cities = await Helper.getCities(queryData);

					if (multiSelectState.cities instanceof Array)
						multiSelectState.cities = [...multiSelectState.cities, ...cities];
					else multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return { label: city.name, value: city.id };
					});

					multiSelectState.citiesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const setCity = (dataObj) => {
				if (!dataObj) {
					data.city.id = 0;
					data.city.name = null;
					return;
				}
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);
				data.city.id = city[0].id;
				data.city.name = city[0].name;
				getHotels({ city: data.city.name });
			};

			const setStarRating = (rating) => {
				if (!rating) return;

				data.starRating = rating;
			};

			const setRoomType = (type) => {
				if (!type) return;
				data.roomType = type;
			};
			const setHotel = (hotel) => {
				if (!hotel) return;
				data.hotel = hotel;
			};

			if (
				props.defaultData instanceof Array ||
				props.defaultData instanceof Object
			) {
				let keys = Object.keys(data);
				keys.map((key) => (data[key] = props.defaultData[key] || data[key]));
				data.checkIn = props.defaultData?.checkIn.split("T")[0];
				data.checkOut = props.defaultData?.checkOut.split("T")[0];

				multiSelectState.cities = [
					...multiSelectState.cities,
					{
						id: props.defaultData?.city.id,
						name: props.defaultData?.city.name,
					},
				];
				multiSelectState.citiesSelect = [
					...multiSelectState.citiesSelect,
					{
						value: props.defaultData?.city.id,
						label: props.defaultData?.city.name,
					},
				];
				getHotels({ city: data.city.name });
			}

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				formState,
				multiSelectState,

				setCountry,
				getCities,
				setCity,
				setStarRating,
				setRoomType,
				setHotel,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
